import { createFileRoute } from "@tanstack/react-router";
import AdminDiscountEdit from "@/pages/admin/AdminDiscountEdit";

export const Route = createFileRoute("/_adminLayout/admin/parts/discounts/$id")({
  component: AdminDiscountEdit,
});
